import React from 'react';
import MarkDown from '@/components/Documents/docs/MarkDown';

const md = `
# 适用场景

用于外部服务商提供 API 给我司使用，而鉴权统一使用我司开放平台统一鉴权方案。
`;

export default function () {
  return (
    <MarkDown docs={md}></MarkDown>
  )
}
